import React from 'react';
import Button from 'devextreme-react/button';

import DataItemView from '../../../common/view/DataItemView';

import TableauPageView from './TableauPageView';

export default class TableauPageListView extends DataItemView {
  static displayName = TableauPageListView.name;

  constructor(props) {
    super(props);

    this.createTableauPageListener = this.onCreateTableauPage.bind(this);
    this.removeTableauPageListener = this.onRemoveTableauPage.bind(this);

    this.bindDataItem(props.tableauPageList);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.tableauPageList);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className="pwx-tableau-page-list-view">
        <div className="pwx-tableau-page-list-content">
          {
            this.state.dataObjects.map(
              tableauPage => (<TableauPageView key={tableauPage.key} tableauPage={tableauPage} onRemoveTableauPage={this.removeTableauPageListener} />)
            )
          }
          <div className="pwx-tableau-page-list-command">
            <Button type="normal" text="Add Tableau Page" onClick={this.createTableauPageListener} />
          </div>
        </div>
      </div>
    );
  }

  onCreateTableauPage() {
    if (this.dataItem === null)
      return;

    this.dataItem.insertNewDataObject();
  }

  onRemoveTableauPage(tableauPage) {
    if (this.dataItem === null)
      return;

    if (tableauPage.isNew)
      this.dataItem.removeDataObject(tableauPage);
    else
      tableauPage.setIsDeleted(true);
  }
}